import { styled } from "@pigment-css/react";
import { ChevronRightThin } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import {
  HoverRowItem,
  RowBody,
  RowChevron,
  RowMeta,
  RowTitle,
  RowValue,
} from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { formatPercentage, type PeerPotentialsItem } from "@acto/taskpane/field-sales-2/data-access/usePeerPotentials";

export const PeerRowItem = styled(HoverRowItem)(({ theme }) => ({
  paddingBlock: theme.fieldSalesTwo.spacing[16],
  "&:first-of-type": {
    paddingTop: theme.fieldSalesTwo.spacing[16],
  },
}));

const PotentialValue = styled(RowValue)(({ theme }) => ({
  color: theme.fieldSalesTwo.colors.status.success.main,
}));

interface DrilldownRowProps {
  row: PeerPotentialsItem;
  locale: string;
  showAdoption?: boolean;
  onOpen?: (row: PeerPotentialsItem) => void;
}

export function PeerPotentialsRow({ row, locale, showAdoption = true, onOpen }: DrilldownRowProps) {
  const t = useTranslations("fieldSalesTwo.peerPotentials");
  const canOpen = row.hasChildren && !!onOpen;

  return (
    <PeerRowItem clickable={canOpen} onClick={canOpen ? () => onOpen(row) : undefined}>
      <RowBody>
        <RowTitle>{row.productName}</RowTitle>
        {showAdoption && (
          <RowMeta>{t("adoptionLabel", { percent: formatPercentage(row.peerAdoptionPercentage, locale) })}</RowMeta>
        )}
        {row.kind !== "RANKED_ONLY" && <PotentialValue>{row.formattedValue ?? "—"}</PotentialValue>}
      </RowBody>
      {canOpen && (
        <RowChevron>
          <ChevronRightThin strokeWidth={1.5} />
        </RowChevron>
      )}
    </PeerRowItem>
  );
}
